import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../icons/error.svg';

type InputValidationErrorProps = {
	message?: string;
};

export const InputValidationError = ({ message }: InputValidationErrorProps) => {
	const { t } = useTranslation();

	return (
		<div className='InputValidation'>
			<img className='InputValidation__Icon' src={ErrorIcon} alt={t('aria.error_icon')} />
			<div role='alert' className='InputValidation__Message InputValidation__Message--error'>
				{message}
			</div>
		</div>
	);
};
